<div mat-dialog-actions class='px-0'>
    <button class="" type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button class="success" mat-stroked-button>Save</button>
</div>
